<template>
  <div class="collapse-container shadow-sm rounded">
    <div
      :aria-controls="key"
      :aria-expanded="model ? 'true' : 'false'"
      class="d-flex collapse-header"
      :class="{ pointer: !disabled }"
      @click="toggle"
    >
      <div class="row no-gutters align-items-center w-100">
        <div class="col-auto mr-2">
          <div
            class="collapse-icon rounded-circle text-white"
            :style="{
              backgroundColor: disabled ? '#3F5B60' : '#FF7058',
            }"
          >
            <i
              class="far "
              :class="{
                'fa-chevron-down': model,
                'fa-chevron-right': !model,
              }"
            />
          </div>
        </div>
        <div class="font-weight-bold col">
          {{ title }}
        </div>
        <div v-if="!disabled" class="col-auto ml-auto">
          <action-button
            i="far fa-times-circle"
            variant="border-0 bg-transparent p-0 text-danger"
            @click="remove"
          />
        </div>
        <div class="col-12 mt-2">
          {{ description }}
        </div>
      </div>
    </div>
    <b-collapse :id="key" class="my-3" :visible="model">
      <slot />
    </b-collapse>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';

export default {
  name: 'SkillCollapse',
  components: {
    ActionButton,
  },
  props: {
    value: {
      type: Boolean,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    divider: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const uid =
      crypto?.randomUUID?.() ||
      Math.random()
        .toString(36)
        .slice(2);
    return {
      opened: false,
      key: `collapse-${uid}`,
      id: `cid-${uid}`,
      unregister: null,
    };
  },
  computed: {
    model: {
      get() {
        return [true, false].includes(this.value) ? this.value : this.opened;
      },
      set(val) {
        if ([true, false].includes(this.value)) this.$emit('input', val);
        else this.opened = val;
      },
    },
  },
  mounted() {},
  methods: {
    toggle() {
      this.model = !this.model;
      this.$emit('toggled', this.model);
    },
    setOpen(val) {
      this._setOpenInternal(val);
    },
    _setOpenInternal(val) {
      if (this.disabled) return;
      this.model = !!val;
      this.$emit('toggled', this.model);
    },
    remove() {
      this.$emit('remove');
    },
  },
};
</script>
<style scoped>
.collapse-header {
  width: 100%;
}
.pointer {
  cursor: pointer;
}
.collapse-icon {
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
  border: 1px solid #ffffff;
  background-color: #2db782;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
.divider {
  margin: 30px -10px !important;
}

.collapse-container {
  background-color: #fafafa;
  padding: 15px;
  margin-bottom: 10px;
}
</style>
